export const en = {
    'LOCALE.SITE.TTILE': 'Deadly Arcade',
    'LOCALE.GAME': 'Play',
    'LOCALE.CHARACTERES': 'Characters',
    "LOCALE.VIDEO": 'Trailer',
    "LOCALE.RANKING": 'Ranking',
    "LOCALE.SOCIAL": 'Social',
    "LOCALE.SOUNDTRACK": 'Soundtrack',
    "LOCALE.SCREENSHOTS": 'Screenshot',

    'LOCALE.VIDEO.BTN': 'TV button ilustration',
    
    "LOCALE.GAME.BEST_SCORE": 'Best score',

    "LOCALE.RANKING.HEADER.NAME": 'Name',
    "LOCALE.RANKING.HEADER.COUNTRY": 'Country',
    "LOCALE.RANKING.HEADER.SCORE": 'Score',
    "LOCALE.RANKING.PLACEHOLDER": 'No data',

    "LOCALE.SHARE.WHATSAPP": "Share in Whatsapp",
    "LOCALE.SHARE.FACEBOOK": "Share in Facebook",
    "LOCALE.SHARE.TWITTER": "Share in Twitter",

    "LOCALE.SOUNDTRACK.PLAY": 'Play sound',
    "LOCALE.SOUNDTRACK.PAUSE": 'Pause sound',
    "LOCALE.SOUNDTRACK.CHOOSE": 'Choose a track',
    "LOCALE.SOUNDTRACK.THEME": 'Deadly Arcade',
    "LOCALE.SOUNDTRACK.CARTOON": 'Papel\'s stage',
    "LOCALE.SOUNDTRACK.MEDIEVAL": 'Helada\'s stage',
    "LOCALE.SOUNDTRACK.TERROR": 'Invertida\'s stage',
    "LOCALE.SOUNDTRACK.ZOMBIE": 'Apocalipse\'s stage',
    
    "LOCALE.SOUNDTRACK.BUTTON.THEME": 'Select music Deadly Arcade',
    "LOCALE.SOUNDTRACK.BUTTON.CARTOON": 'Select music Papel\'s stage',
    "LOCALE.SOUNDTRACK.BUTTON.MEDIEVAL": 'Select music Helada\'s stage',
    "LOCALE.SOUNDTRACK.BUTTON.TERROR": 'Select music Invertida\'s stage',
    "LOCALE.SOUNDTRACK.BUTTON.ZOMBIE": 'Select music Apocalipse\'s stage',
    
    "LOCALE.IOC.ARG": "Argentina", 
    "LOCALE.IOC.BOL": "Bolivia", 
    "LOCALE.IOC.BRA": "Brazil", 
    "LOCALE.IOC.CHI": "Chile", 
    "LOCALE.IOC.COL": "Colombia", 
    "LOCALE.IOC.CRC": "Costa Rica", 
    "LOCALE.IOC.CUB": "Cuba", 
    "LOCALE.IOC.ESA": "El Salvador", 
    "LOCALE.IOC.ECU": "Ecuador", 
    "LOCALE.IOC.GUA": "Guatemala", 
    "LOCALE.IOC.HAI": "Haiti", 
    "LOCALE.IOC.HON": "Honduras", 
    "LOCALE.IOC.MEX": "Mexico", 
    "LOCALE.IOC.UNK": "Worldwide", 
    "LOCALE.IOC.NCA": "Nicaragua", 
    "LOCALE.IOC.PAN": "Panama", 
    "LOCALE.IOC.PAR": "Paraguay", 
    "LOCALE.IOC.PER": "Peru", 
    "LOCALE.IOC.DOM": "Dominican Republic", 
    "LOCALE.IOC.URU": "Uruguay", 
    "LOCALE.IOC.VEN": "Venezuela", 

    "LOCALE.ACCESSIBILITY.MARCUS.TITLE": "About Marcus Lopez",
    "LOCALE.ACCESSIBILITY.MARCUS.ALTERNATIVE_IMAGE_DATA": "Marcus Lopez's Illustration",
    "LOCALE.ACCESSIBILITY.MARCUS.BUTTON": 'Select Marcus Lopez',

    "LOCALE.ACCESSIBILITY.SAYA.TITLE": "About Saya",
    "LOCALE.ACCESSIBILITY.SAYA.ALTERNATIVE_IMAGE_DATA": "Saya's Illustration",
    "LOCALE.ACCESSIBILITY.SAYA.BUTTON": 'Select Saya',

    "LOCALE.ACCESSIBILITY.BILLY.TITLE": "About Billy",
    "LOCALE.ACCESSIBILITY.BILLY.ALTERNATIVE_IMAGE_DATA": "Billy's Illustration",
    "LOCALE.ACCESSIBILITY.BILLY.BUTTON": 'Select Billy',
    
    "LOCALE.ACCESSIBILITY.MARIA.TITLE": "About Maria",
    "LOCALE.ACCESSIBILITY.MARIA.ALTERNATIVE_IMAGE_DATA": "Maria's Illustration",
    "LOCALE.ACCESSIBILITY.MARIA.BUTTON": 'Select Maria',
    
    "LOCALE.ACCESSIBILITY.MASTER.TITLE": "About Master Lin",
    "LOCALE.ACCESSIBILITY.MASTER.ALTERNATIVE_IMAGE_DATA": "Master Lin's Illustration",
    "LOCALE.ACCESSIBILITY.MASTER.BUTTON": 'Select Master Lin',

    "LOCALE.ACCESSIBILITY.SCREENSHOT.1": "Gameplay's screenshot 1",
    "LOCALE.ACCESSIBILITY.SCREENSHOT.2": "Gameplay's screenshot 2",
    "LOCALE.ACCESSIBILITY.SCREENSHOT.3": "Gameplay's screenshot 3",
    "LOCALE.ACCESSIBILITY.SCREENSHOT.4": "Gameplay's screenshot 4",
    "LOCALE.ACCESSIBILITY.SCREENSHOT.5": "Gameplay's screenshot 5",
    "LOCALE.ACCESSIBILITY.SCREENSHOT.6": "Gameplay's screenshot 6",

    "LOCALE.LIGHTBOX.CLOSE": "Close",
    "LOCALE.LIGHTBOX.BACK": "Back",
    "LOCALE.LIGHTBOX.NEXT": "Next",

    
    "LOCALE.COUNTRY.PLACEHOLDER": "Select country",
    "LOCALE.SCREENSHOT.PLACEHOLDER": "Select screenshot",

}